import React, { useEffect, useState } from 'react';
import Helper from 'src/helper/Helper';
import System from "../../../helper/system";
import ObjCommonFilterSelection from "../../../component/custom/ObjCommonFilterSelection";
import { useObjCommonFilterStore } from "../../../hooks/objCommonFilter";
import Constants from "../../../helper/Constants";

export function QuoteDetailSearchFilter() {
    const [formData, setFormData] = useState({ searchBy: '', searchVal: '' })
    const [{ filter_list }, { }, { set_filter_list }] = useObjCommonFilterStore();
    const [validateDetail, setValidateDetail] = useState([])
    const { siteUser } = Constants;

    const ddlValues = [
        { id: "manufacturerPartNumber", text: "Manufacturer Part Number" },
    ];
    if (System.avUserInfoData.currentUser === siteUser.CORE) {
      ddlValues.push({ id: "customerPartNumber", text: "Customer Part Number" })
    }
    const onValueChange = (value) => {
        setFormData({ ...formData, searchVal: value })
        validateOnChange(value);
    }
    const validateOnChange = (value) => {
        if (value) {
            const isValid = Helper.validateMinCharacter(value);
            if (isValid) {
                const validateData = { ...validateDetail };
                delete validateData.searchVal;
                setValidateDetail(validateData)
            }
        }
    }

    useEffect(() => {
        let flag = true;
        Object.entries(filter_list).forEach(([key, value]) => {
            if (ddlValues.map(v => v.id).includes(key)) {
                flag = false;
                setFormData({
                    searchBy: key,
                    searchVal: value.searchKeyword
                });
            }
        })
        if (flag) {
            setFormData({
                searchBy: "",
                searchVal: ""
            });
        }
    }, [filter_list])

    const onSearchChange = (e) => {
        setFormData({ ...formData, searchBy: e.target.value })
        if (e.target.value) {
            const validateData = { ...validateDetail };
            delete validateData.searchBy;
            setValidateDetail(validateData)
        }
    }

    const onSearch = (e) => {
        const isValid = validateData();

        if (isValid) {
            const detail = {
                searchKey: formData.searchBy,
                searchKeyword: formData.searchVal.trim(),
                searchType: ddlValues.find(f => f.id === formData.searchBy).text
            }
            set_filter_list({ [formData.searchBy]: detail });
        }
    }

    const validateData = () => {
        if (!formData.searchBy) {
            setValidateDetail({ searchBy: 'Please select a "Search By" Option' })
            return false
        }

        if (!formData.searchVal) {
            setValidateDetail({ searchVal: 'Search value is required' })
            return false
        } else {
            const isValid = Helper.validateMinCharacter(formData.searchVal);
            if (isValid === false) {
                setValidateDetail({ searchVal: 'Please enter at least 3 characters to execute a keyword search' });
                return false
            }
        }
        return true;
    }

    return (
        <>
            <h4 className='mb-0 mt-1'>Quote Breakdown</h4>
            <hr></hr>
            <div className="d-flex align-items-top">
                <div>
                    <div className="dropdown quote-search-dd me-3">
                        <div className="selectbox">
                            <select className="form-control form-control-sm mr-3" aria-label="Search By" id="searchBy" onChange={onSearchChange} defaultValue={formData.searchBy} >
                                <option value="" key="3" >Search By</option>
                                {ddlValues && (ddlValues).map((v, i) => (
                                    <option selected={v.id === formData.searchBy} key={v.id} value={v.id}>{v.text}</option>
                                ))}
                            </select>
                        </div>
                        {validateDetail?.searchBy && <p className="error">{validateDetail?.searchBy}</p>}
                    </div>
                </div>
                <div>
                    <div className="bs5 input-group flex-nowrap">
                        <input type="search" className="form-control form-control-sm"
                            placeholder="Search by keyword"
                            value={formData.searchVal}
                            onChange={({ target: { value } }) => onValueChange(value)}
                            onKeyPress={(e) => Helper.onEnterKeyPress(e) === true ? onSearch() : ''} />

                        <a href={void (0)} className="bs5 btn btn-secondary d-flex align-items-center rounded-right-1" onClick={onSearch}>
                            <i className="fa fa-search text-black-stone  text-black-stone"></i>
                        </a>
                    </div>
                    {validateDetail?.searchVal && <p className="error">{validateDetail?.searchVal}</p>}
                </div>
                <div className="bs5 ms-2 mt-1 pt-1">
                    <a href={void (0)}
                        onClick={() => {
                            System.popup('QuoteDetailFilterPopup')
                        }}>Advanced Filters</a>
                </div>
            </div>
            <ObjCommonFilterSelection />
        </>
    );

}

